import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { FrontendEnaioMapper } from 'src/modules/enaio/models/frontend-enaio-mapper.model';
import { EnaioCallGetWorkflowModels } from 'src/modules/enaio/shared/EnaioCallGetWorkflowModels';
import { EnaioCallSaveWorkflowScript } from 'src/modules/enaio/shared/EnaioCallSaveWorkflowScript';
import { EnaioWorkflowApplicationDefinition } from 'src/modules/enaio/shared/EnaioWorkflowApplicationDefinition';
import { EnaioWorkflowDataField } from 'src/modules/enaio/shared/EnaioWorkflowDataField';
import { EnaioWorkflowEventDefinition } from 'src/modules/enaio/shared/EnaioWorkflowEventDefinition';
import { EnaioWorkflowMaskFieldDefinition } from 'src/modules/enaio/shared/EnaioWorkflowMaskFieldDefinition';
import { EnaioWorkflowModel } from 'src/modules/enaio/shared/EnaioWorkflowModel';
import { EnaioWorkflowModelState } from 'src/modules/enaio/shared/EnaioWorkflowModelState';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldListItem } from 'src/modules/sm-base/models/frontend-field-list-item.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { OrdinaryObject } from 'src/modules/utils/shared/ordinary-object.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { DhTools } from '../../models/dh-tools.model';
import { FrontendScriptDefinition } from '../../models/frontend-script-definition.model';
import { FrontendScriptsDefinition } from '../../models/frontend-scripts-definition.model';
import { TableCellEvent } from 'src/modules/sm-base/models/table-cell-event.model';
import { TableCellButton } from 'src/modules/sm-base/models/table-cell-button.model';
import { EnaioGuiField } from 'src/modules/enaio/shared/EnaioGuiField';

@Component({
    selector: 'app-enaio-workflow-models',
    templateUrl: './enaio-workflow-models.component.html',
    styleUrls: ['./enaio-workflow-models.component.scss']
  })
  export class EnaioWorkflowModelsComponent extends ComponentView {

    models: EnaioWorkflowModel[];
    sel: EnaioWorkflowModel;
    families: { id: string; name: string }[];
    formFilter: FrontendFormDefinition;
    selectedMask: string;
    fieldsTable: TableData;
    variablesTable: TableData;
    masksGui: FrontendFieldListItem[] = [];
    scripts = new FrontendScriptsDefinition();
    pastModels: EnaioWorkflowModel[] = null;
    selectedMaskFields: EnaioGuiField[];

    async initParams(): Promise<boolean> {
        this.models = Utils.arraySortBy(await DhTools.enaioCall<EnaioWorkflowModel[]>(new EnaioCallGetWorkflowModels()), m => m.version);
        this.families = Utils.arraySort(Utils.arrayGetUnique(this.models.map(m => ({id: m.family.id, name: m.family.name})), m => m.id));
        this.formFilter = new FrontendFormDefinition([
            new FrontendFieldDefinition("familyName", "Workflow-Familie", FrontendFieldType.comboBox, { value: this.families[0], mandatory: true, dropdownEditable: false,
                listItems: Utils.arraySort(this.families.map(f => new FrontendFieldListItem(f, f.name))), onValueChanged: this.workflowFamilyChanged.bind(this)}),
            new FrontendFieldDefinition("modelName", "Workflow-Modell", FrontendFieldType.comboBox, { mandatory: true, dropdownEditable: false})
        ]);
        this.workflowFamilyChanged();

        return true;
    }

    workflowFamilyChanged(): void {
        this.pastModels = null;
        let familyId = this.formFilter.getValue("familyName")?.id;
        let items = Utils.arraySort(this.models.filter(m => m.family.id == familyId).map(m => new FrontendFieldListItem(m.id, (m.state == EnaioWorkflowModelState.active ? "[Aktiv] " : m.state == EnaioWorkflowModelState.inUse ? "[In Benutzung] " : "") + m.name + " (v" + m.version + ")", { comparable: Utils.expandNumber(m.version, 10) })), null, false);
        this.formFilter.getField("modelName").listItems = items;
        this.formFilter.setValue("modelName", Utils.arrayGetSafe(items, 0)?.value);
    }

    async saveMasksAsObjectDef(): Promise<void> {
        let fileName = await DhTools.saveDialog("objdefwfs.xml");
        await DhTools.backendCall("api/enaio/workflowMasksToObjectType", { fileName }).getText();
        DhTools.backendCall("api/system/openDir", { fileName }).getText()
    }

    async open(): Promise<void> {
        let call = Utils.fromPlain(EnaioCallGetWorkflowModels, Utils.objectRemoveNullValues({
            modelIds: [this.formFilter.getValue("modelName")],
            getDefinition: true
        }));
        this.sel = Utils.arrayGetSafe(await DhTools.enaioCall(call), 0);
        if (this.sel != null) {
            this.masksGui = Utils.arraySortBy(this.sel.definition.masks, m => m.name).map(mask => new FrontendFieldListItem(mask.id, mask.name));
            this.selectedMask = this.masksGui[0].value;
            this.changeMask();
        }

        this.variablesTable = new TableData([
            new TableColumn("name", "Name", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("id", "DataField ID", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("description", "Beschreibung", TableCellType.text, { autoWidth: 15 }),
            //new TableColumn("dataType", "Datentyp", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("length", "Länge", TableCellType.int, { autoWidth: 5 })
        ], this.sel.definition.dataFields.map(df => new TableRow("", df, {
            name: df.name,
            id: df.id,
            description: df.description,
           // dataType: df.dataType,
            length: df.length
        })));

        this.updateScripts();
    }

    updateScripts(): void {
        this.scripts = DhTools.workflowToScriptDefinition(this.sel, this.pastModels);
    }

    getDataFieldsForMaskField(apps: EnaioWorkflowApplicationDefinition[], maskField: EnaioWorkflowMaskFieldDefinition): EnaioWorkflowDataField[] {
        let result: EnaioWorkflowDataField[] = [];
        for (let app of apps) {
            for (let activity of this.sel.definition.activities) {
                for (let app2 of activity.applications) {
                    if (app2.id == app.id) {
                        for (let p of app.formalParameters) {
                            if (p.id == maskField.id) {
                                let variableId = Utils.arrayGetSafe(app2.actualParameters, p.index - 1);
                                if (variableId != null) {
                                    let dataField = this.sel.definition.dataFields.find(df => df.id == variableId);
                                    if (dataField != null) {
                                        result = [...result, dataField];
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return result;
    }

    changeMask(): void {
        let mask = this.sel.definition.masks.find(mask2 => mask2.id == this.selectedMask);
        let apps = this.sel.definition.applications.filter(a => a.maskId == mask.id);

        this.fieldsTable = new TableData([
            new TableColumn("name", "Name", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("variableNames", "Variablennamen", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("dataFieldIds", "DataField IDs", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("dataType", "Datentyp", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("addOnParams", "AddOn-Parameter", TableCellType.text, { autoWidth: 30 }),
            new TableColumn("_edit", "", TableCellType.button, { autoWidth: 1 })
        ], mask.fields.map(f => {
            let dataFields = this.getDataFieldsForMaskField(apps, f);
            return new TableRow("", f, {
                name: f.name,
                variableNames: Utils.arrayItemsToString(Utils.arrayGetUnique(dataFields.map(df => df.name))),
                dataFieldIds: Utils.arrayItemsToString(Utils.arrayGetUnique(dataFields.map(df => df.id))),
                dataType: f.dataType,
                addOnParams: f.maskFieldVal,
                _edit: [new TableCellButton("edit", "fas fa-pencil", "Editieren")]
            } as OrdinaryObject);
        }));
        this.selectedMaskFields = mask.fields.map(f => f.guiField);
    }

    async editField(event: TableCellEvent): Promise<void> {
        if (event.isButton("edit", "_edit")) {
            let form = new FrontendFormDefinition([
                new FrontendFieldDefinition("addOnParams", "AddOn-Parameter", FrontendFieldType.textArea, { value: event.row.raw.maskFieldVal, monospaced: true })
            ]);
            if (await this.app.messageDialog.form(form, "Addon-Parameter ändern", [this.app.messageDialog.save, this.app.messageDialog.cancel]) == "save") {
                let v = form.getValue("addOnParams");
                if (v != event.row.raw.maskFieldVal && await this.app.messageDialog.yesNo("WIRKLICH ÄNDERN? AUF EIGENE GEFAHR!!!", "WARNUNG")) {
                    await DhTools.backendCall("api/enaio/changeWfMaskField", { valuesId: event.row.raw.valuesId, maskFieldVal: v}).getString();
                }
            }
        }
    }

    async select(modelId: string): Promise<void> {
        let model = this.models.find(m => m.id == modelId);
        if (model != null) {
            this.formFilter.setValue("familyName", this.families.find(item => item.id == model.familyId));
            this.workflowFamilyChanged();
            this.formFilter.setValue("modelName", model.id);
            await this.open();
        }
    }

    async saveWorkflowScript(items: FrontendScriptDefinition[]): Promise<void> {
        await DhTools.enaioCall(Utils.fromPlain(EnaioCallSaveWorkflowScript, {
            modelId: this.sel.id,
            scriptId: (items[0].raw as EnaioWorkflowEventDefinition).scriptId,
            scriptLanguage: (items[0].raw as EnaioWorkflowEventDefinition).language,
            code: items[0].code
        }));
    }

    async loadHistory(): Promise<void> {
        let familyId = this.formFilter.getValue("familyName")?.id;
        let call = Utils.fromPlain(EnaioCallGetWorkflowModels, Utils.objectRemoveNullValues({
            modelIds: this.models.filter(m => m.family.id == familyId).map(m => m.id),
            getDefinition: true
        }));
        this.pastModels = await DhTools.enaioCall(call);
        this.updateScripts();
    }
}